export type PriceCardUsp = {
  title: string;
  subline: string;
};

export const SUBSCRIPTION_USPS: PriceCardUsp[] = [
  {
    title: 'Hands-on projects',
    subline: 'Real work critiqued by industry pros',
  },
  {
    title: 'Personalized career feedback',
    subline: 'On resumes, LinkedIn, and GitHub',
  },
  {
    title: 'Recognized certificates',
    subline: 'Proof of skills for hiring managers',
  },
  {
    title: '500+ courses, unlimited access',
    subline: 'One subscription, the entire catalog',
  },
  {
    title: 'Cancel anytime',
    subline: 'No long-term commitment',
  },
];

export const STANDALONE_USPS: PriceCardUsp[] = [
  {
    title: 'Real-world projects',
    subline: 'Build a portfolio that gets you hired',
  },
  {
    title: 'Expert feedback on your work',
    subline: 'Every submission reviewed by a pro',
  },
  {
    title: 'Recognized certificate',
    subline: 'Proof of skills for hiring managers',
  },
  {
    title: 'Learn at your own pace',
    subline: 'Finish on your own schedule',
  },
  {
    title: 'One-time payment',
    subline: 'No subscription, no recurring fees',
  },
];
